(function () {
  function getTabResults(data, success, error) {
    $.ajax({
      method: 'GET',
      url: '/api/tab',
      data: {
        params: {
          page: data.page,
          type: data.type,
          //suburb: $('.ateed-taste-search #taste-location').val(),
          //cuisine: $('.ateed-taste-search #taste-cuisine').val(),
          alphabetical: data.alphabetical,
          rating: data.rating,
          arg: data.arg
          //default_search: data.default_search
        }
      },
      success: success,
      error: error
    });
  }
  function getTasteResults(data, success, error) {
    $.ajax({
      method: 'GET',
      url: '/api/taste',
      data: {
        params: {
          page: data.page,
          region: $('.ateed-taste-search #taste-region').val(),
          region_suburb: $('.ateed-taste-search #taste-suburb').val(),
          suburb: $('.ateed-taste-search #taste-location').val(),
          cuisine: $('.ateed-taste-search #taste-cuisine').val(),
          alphabetical: data.alphabetical,
          rating: data.rating,
          default_search: data.default_search
        }
      },
      success: success,
      error: error
    });
  }

  function getStayResults(data, success, error) {
    $.ajax({
      method: 'GET',
      url: '/api/stay',
      data: {
        params: {
          page: data.page,
          region: $('.ateed-stay-search #stay-region').val(),
          region_suburb: $('.ateed-stay-search #stay-suburb').val(),
          suburb: $('.ateed-stay-search #stay-location').val(),
          category: $('.ateed-stay-search #stay-type').val(),
          price: $('.ateed-stay-search #stay-price').val(),
          endorsed: $('.ateed-stay-search #stay-qualmark-endorsed').is(':checked'),
          rated: $('.ateed-stay-search #stay-qualmark-enviro-rated').is(':checked'),
          booking: $('.ateed-stay-search #stay-online-booking-only').is(':checked'),
          alphabetical: data.alphabetical,
          rating: data.rating,
          default_search: data.default_search
        }
      },
      success: success,
      error: error
    });
  }

  function getActivitiesAndAttractionsResults(data, success, error) {
    $.ajax({
      method: 'GET',
      url: '/api/activities-and-attractions',
      data: {
        params: {
          page: data.page,
          region: $('.ateed-aaa-search #aaa-region').val(),
          suburb: $('.ateed-aaa-search #aaa-location').val(),
          category: $('.ateed-aaa-search #aaa-type').val(),
          price: $('.ateed-aaa-search #aaa-price').val(),
          endorsed: $('.ateed-aaa-search #aaa-qualmark-endorsed').is(':checked'),
          rated: $('.ateed-aaa-search #aaa-qualmark-enviro-rated').is(':checked'),
          booking: $('.ateed-aaa-search #aaa-online-booking-only').is(':checked'),
          alphabetical: data.alphabetical,
          default_search: data.default_search
        }
      },
      success: success,
      error: error
    });
  }

  function getEventResults(data, success, error) {
    $.ajax({
      method: 'GET',
      url: '/api/events',
      data: {
        params: {
          page: data.page,
          type: $('.ateed-events-search #event-type').val(),
          region: $('.ateed-events-search #event-region').val(),
          suburb: $('.ateed-events-search #event-location').val(),
          from: $('.date-range-wrapper').data('daterangepicker').startDate.format('YYYY-MM-DD'),
          to: $('.date-range-wrapper').data('daterangepicker').endDate.format('YYYY-MM-DD'),
          alphabetical: data.alphabetical,
          default_search: data.default_search
        }
      },
      success: success,
      error: error
    });
  }

  function getACBResults(data, success, error) {
    var url = '';
    var params = {
      page: data.page,
      alphabetical: data.alphabetical,
      default_search: data.default_search
    };

    if (data.type === 'venues') {
      url = '/api/acb-venues';
      params.room_type = $('.ateed-acb-search #acb-room').val();
      params.room_type_name = $('.ateed-acb-search #acb-room option:selected').text();
      params.suburb = $('.ateed-acb-search #acb-location').val();
      params.attendees = $('.ateed-acb-search #acb-delegates').val();
    } else if (data.type === 'venues_accommodation') {
      url = '/api/acb-venues-accommodation';
      params.room_type = $('.ateed-acb-search #acb-accommodation-room').val();
      params.room_type_name = $('.ateed-acb-search #acb-accommodation-room option:selected').text();
      params.suburb = $('.ateed-acb-search #acb-location-accommodation').val();
      params.attendees = $('.ateed-acb-search #acb-delegates').val();
    } else if (data.type === 'services') {
      url = '/api/acb-services';
      params.service_type = $('.ateed-acb-search #acb-service-type').val();
      params.suburb = $('.ateed-acb-search #acb-service-location').val();
    } else if (data.type === 'activities') {
      url = '/api/acb-activities';
      params.activity_type = $('.ateed-acb-search #acb-activity-type').val();
      params.suburb = $('.ateed-acb-search #acb-activity-location').val();
    } else if (data.type === 'transport') {
      url = '/api/acb-transport';
      params.transport_type = $('.ateed-acb-search #acb-transport-type').val();
      params.suburb = $('.ateed-acb-search #acb-transport-location').val();
    } else if (data.type === 'business_name') {
      url = '/api/acb-business-name';
      params.name = $('.ateed-acb-search #acb-business-name').val();
    }

    $.ajax({
      method: 'GET',
      url: url,
      data: {
        params: params
      },
      success: success,
      error: error
    });
  }

  function getEducationResults(data, success, error) {
    $.ajax({
      method: 'GET',
      url: '/api/education',
      data: {
        params: {
          page: data.page,
          type: $('.ateed-education-search #education-type').val(),
          suburb: $('.ateed-education-search #education-location').val(),
          alphabetical: data.alphabetical,
          default_search: data.default_search
        }
      },
      success: success,
      error: error
    });
  }

  window.Ateed.Components.ModalResults = function() {
    $(document).on('keyup','input#acb-delegates',function(e){
      $(this).val($(this).val().replace(/[^\d]/g,''));
    });
    $('[data-target="#resultsModal"]').on('click', function (e) {
      clickedBtn = this;

      var searchType = null;

      if ($(this).hasClass('ateed-taste-submit')) searchType = 'taste';
      else if ($(this).hasClass('ateed-tab-submit')) searchType = 'tab';
      else if ($(this).hasClass('ateed-stay-submit')) searchType = 'stay';
      else if ($(this).hasClass('ateed-aaa-submit')) searchType = 'aaa';
      else if ($(this).hasClass('ateed-events-submit')) searchType = 'events';
      else if ($(this).hasClass('ateed-acb-submit')) searchType = 'acb';
      else if ($(this).hasClass('ateed-acb-submit2')) searchType = 'acb2';
      else if ($(this).hasClass('ateed-education-submit')) searchType = 'education';

      $('.ateed-modal-wrapper').html(
        '<div class="modal fade" id="resultsModal" tabindex="-1" role="dialog" aria-labelledby="resultsModalLabel">' +
          '<search-results :items="items" :loaded="loaded" :pages="pages" :page-number="pageNumber" :pages-in-pagination-bar="pagesInPaginationBar" :change-page="changePage" :results-text="resultsText" :search-text="searchText" :menu-open="menuOpen" :open-menu="openMenu" :filters="filters" :change-filters="changeFilters" :show-rating-filter="showRatingFilter" :show-soonest-filter="showSoonestFilter" :rating-text="ratingText" :is-event="isEvent"></search-results>' +
        '</div>'
      );

      Vue.component('search-results', {
        props: [
          'changeFilters',
          'changePage',
          'filters',
          'items',
          'loaded',
          'menuOpen',
          'openMenu',
          'pages',
          'pagesInPaginationBar',
          'pageNumber',
          'isEvent',
          'ratingText',
          'resultsText',
          'searchText',
          'showRatingFilter',
          'showSoonestFilter'
        ],
        template: '@@import modal-results.html'
      });

      var maxPages = $(window).innerWidth() >= 640 ? 5 : 3;

      var viewModel = new Vue({
        el: '.ateed-modal-wrapper',
        data: function () {
          return this.initialData();
        },
        computed: {
          pages: function () {
            return Array.apply(null, Array(Math.ceil(this.total_results / this.itemsPerPage))).map(function (e, i) {
              return { id: i + 1 };
            });
          },
          pagesInPaginationBar: function () {
            if (this.pageNumber <= maxPages) return this.pages.slice(0, maxPages);
            if (this.pages.length - this.pageNumber < maxPages) return this.pages.slice(-maxPages);
            return this.pages.slice(this.pageNumber - maxPages, this.pageNumber);
          },
          resultsText: function () {
            if (this.total_results === 0) return '0 results';
            if (this.total_results === 1) return '1 result';
            return this.from + ' to ' + this.to + ' of ' + this.total_results + ' results';
          },
          searchText: function () {
            if (this.searchType === 'taste') return 'for Taste Auckland';
            else if (this.searchType === 'tab') {
              var heading = $(clickedBtn).closest('.paragraph--type--location-specific-tabs-component').find('.field--name-field-lstc-heading');
              if (heading.length>0) {
                return heading.text();
              }
              return ' for Plan and book your event experience';
            }
            else if (this.searchType === 'stay') return 'for Stay in Auckland';
            else if (this.searchType === 'aaa') return 'for Activities and Attractions in Auckland';
            else if (this.searchType === 'events') return 'for Plan and book your event experience';
            else if (this.searchType === 'acb' || this.searchType === 'acb2') return 'for Plan your event in Auckland';
            else if (this.searchType === 'education') return 'for Find education institution';
          },
          showRatingFilter: function () {
            if (this.searchType === 'taste' || this.searchType === 'stay') {
              return true;
            }
            if (this.searchType === 'tab') {
              var lstc_tab_type = $(clickedBtn).attr('lstc-tab-type');
              if (lstc_tab_type=='activities' || lstc_tab_type=='accommodation' || lstc_tab_type=='dining') {
                return true;
              }
            }
            return false;
          },
          showSoonestFilter: function () {
            if (this.searchType === 'events') return true;
            return false;
          }
        },
        methods: {
          initialData: function () {
            return {
              searchType: null,
              itemsPerPage: 10,
              items: [],
              total_results: 0,
              from: 0,
              to: 0,
              loaded: false,
              pageNumber: 1, // starts at 1
              menuOpen: false,
              filters: {
                alphabetical: undefined,
                rating: undefined
              },
              default_search: true
            };
          },
          changePage: function (page) {
            if (this.pageNumber === page) return;
            else if (page < 1) this.pageNumber = 1;
            else if (page > this.pages.length) this.pageNumber = this.pages.length;
            else if (this.pageNumber !== page) this.pageNumber = page;

            this.getItems(this.pageNumber);
            setTimeout(function () {
              $('.modal-content').animate({ scrollTop: 0 }, 100);
            }, 300);
          },
          openMenu: function (state) {
            if (state === undefined) this.menuOpen = !this.menuOpen;
            else this.menuOpen = state;
          },
          changeFilters: function (filters) {
            if (filters === undefined) {
              // reset filtering
              this.filters = Object.assign({}, this.filters, this.initialData().filters);
              this.default_search = true;
            } else {
              this.filters = Object.assign({}, this.filters, this.initialData().filters, filters);
              this.default_search = false;
            }
            this.getItems();
          },
          strip: function (html) {
              /*var tmp = document.createElement("DIV");
              tmp.innerHTML = html;
              return tmp.textContent || tmp.innerText || "";*/

              //html = html.replace('</p>','<br><br>');
              if (html) {
                html = html.replace(/<br>/g, "$br$");
                html = html.replace(/(?:\r\n|\r|\n)/g, '$br$');
                var tmp = document.createElement("DIV");
                tmp.innerHTML = html;
                html = tmp.textContent || tmp.innerText || "";
                html = html.replace(/\$br\$/g, "<br>");
                return html;
              }
              return '';


              /*var tmp2 = document.createElement("DIV");
              tmp2.innerHTML = html;
              return tmp2.innerHTML;*/
          },
          getItems: function (page, searchType) {
            if (searchType) this.searchType = searchType;
            if (page) this.pageNumber = page;

            this.loaded = false;

            var apiCall = function () {};

            var data = {
              page: this.pageNumber,
              alphabetical: this.filters.alphabetical,
              rating: this.filters.rating,
              default_search: this.default_search
            };

            if (this.searchType === 'taste') apiCall = getTasteResults;
            else if (this.searchType === 'tab') {
              data.type = $(clickedBtn).attr('lstc-tab-type');
              data.arg = $(clickedBtn).attr('lstc-arg');
              apiCall = getTabResults;
            }
            else if (this.searchType === 'stay') apiCall = getStayResults;
            else if (this.searchType === 'aaa') apiCall = getActivitiesAndAttractionsResults;
            else if (this.searchType === 'events') apiCall = getEventResults;
            else if (this.searchType === 'acb' || this.searchType === 'acb2') {
              apiCall = getACBResults;
              data.type = $('.ateed-acb-search #acb-type').val();
              /*if (this.searchType==='acb2') {
                data.default_search = false;
              }*/
            }
            else if (this.searchType === 'education') apiCall = getEducationResults;

            apiCall(data, function(res) {
              // success
              this.items = res.data.items;
              for (var i=0; i < this.items.length; i++) {
                this.items[i].short_description = this.strip(this.items[i].short_description);
              }
              // only set items on page 1 of the api call
              if (page === 1) this.itemsPerPage = res.data.items.length || 10;
              this.total_results = res.data.total_results;
              this.from = res.data.from;
              this.to = res.data.to;
              this.loaded = true;
            }.bind(this), function() {
              // error
              this.items = [];
              this.total_results = 0;
              this.from = 0;
              this.to = 0;
              this.loaded = true;
            }.bind(this));
          },
          isEvent: function (item) {
            if (item.venue || item.date) {
              return true;
            }
            return false;
          },
          ratingText: function (item) {
            if (item.zomato_rating) {
              var rating = item.zomato_rating.split('.');

              return '<ul class="ateed-rating-small">' +
                  Array.apply(null, Array(parseInt(rating[0], 10) + 1)).join('<li class="ateed-star-10-small ateed-indicator"></li>') +
                  '<li class="ateed-star-' + parseInt(rating[1][0], 10) + '-small ateed-indicator"></li>' +
                  Array.apply(null, Array(5 - parseInt(rating[0], 10))).join('<li class="ateed-star-0-small ateed-indicator"></li>')
              '</ul>';
            }
            else return '';
          }
        }
      });

      viewModel.$data = viewModel.initialData();
      viewModel.getItems(1, searchType);

      $('#resultsModal').modal({
        show: false
      });
    });

    // fix checkbox/radio button label structure
    $('.checkbox .control-label, .radio .control-label').each(function () {
      $(this).contents().last().replaceWith(
        '<span>' +
        $(this).contents().last().text().trim() +
        '</span>'
      );
    });

    // select the current sort filter (if applicable)
    if ($('.results_summary').length > 0) {
      $('.results_summary .sort_default').click(function(e){
        e.preventDefault();
        var loc = window.location;
        //var withoutQuery = loc.hostname + loc.pathname;
        var includingProtocol = loc.protocol + "//" + loc.hostname + loc.pathname;
        window.location = includingProtocol;
        return false;
      });
      if (window.location.href.indexOf('ordering=a-z') > -1) {
        $('.results_summary > .results_sort .sort_atoz').addClass('selected');
      }
      else if (window.location.href.indexOf('ordering=soonest') > -1) {
        $('.results_summary > .results_sort .sort_soonest').addClass('selected');
      }
      else if (window.location.href.indexOf('ordering=z-a') > -1) {
        $('.results_summary > .results_sort .sort_ztoa').addClass('selected');
      }
      else {
        $('.results_summary > .results_sort a.sort_default').addClass('selected');
      }
    }
    if ($('.sort_results').length > 0) {
        if (window.location.href.indexOf('ordering=latest') > -1) {
            $($('.sort_results').find('a')[1]).addClass('selected');
        } else if (window.location.href.indexOf('ordering=a-z') > -1) {
            $($('.sort_results').find('a')[2]).addClass('selected');
        } else if (window.location.href.indexOf('ordering=z-a') > -1) {
            $($('.sort_results').find('a')[3]).addClass('selected');
        } else {
            $($('.sort_results').find('a')[0]).addClass('selected');
        }
    }
  }
})();
